export const generateHash = () => Math.random().toString(36).substring(7)
